module.exports = __webpack_public_path__ + "img/SPDB-FPD-detail.e7b66b79.png";